import { Divider, Menu, MenuProps } from "@mui/material";
import React from "react";

import { DataMenuItem } from "./DataMenuItem";
import { MenuItemData } from "./types";

/**
 * @deprecated Use Menu/MenuItems instead
 */
interface DataMenuProps extends MenuProps {
  items: MenuItemData[];
  onCloseMenu?: () => void;
}

export const DataMenu = ({ items, onCloseMenu, ...rest }: DataMenuProps) => {
  let lastGroup = items?.[0]?.group;
  return (
    <Menu {...rest}>
      {items.reduce<React.ReactElement[]>((acc, item) => {
        const next = [...acc];
        if (lastGroup !== item.group) {
          next.push(<Divider key={`divider-${item.group}`} />);
        }
        lastGroup = item.group;
        next.push(
          <DataMenuItem
            data-actionid={item.id}
            data-actiontype="item"
            key={item.name}
            data={item}
            onCloseMenu={onCloseMenu}
          />,
        );
        return next;
      }, [])}
    </Menu>
  );
};
